var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "25px",
    viewBox: "0 0 19 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.12,0 C12.5662568,0 15.36,2.45603794 15.36,5.48571429 L15.36,8.64 L15.96,8.64 C17.2192092,8.64 18.24,9.67153594 18.24,10.944 L18.24,21.696 C18.24,22.9684641 17.2192092,24 15.96,24 L2.28,24 C1.02079077,24 0,22.9684641 0,21.696 L0,10.944 C0,9.67153594 1.02079077,8.64 2.28,8.64 L2.88,8.64 L2.88,5.48571429 C2.88,2.45603794 5.67374316,0 9.12,0 Z M15.96,10.176 L2.28,10.176 C1.86026359,10.176 1.52,10.5198453 1.52,10.944 L1.52,21.696 C1.52,22.1201547 1.86026359,22.464 2.28,22.464 L15.96,22.464 C16.3797364,22.464 16.72,22.1201547 16.72,21.696 L16.72,10.944 C16.72,10.5198453 16.3797364,10.176 15.96,10.176 Z M8.64,13.44 C10.2305801,13.44 11.52,14.7294199 11.52,16.32 C11.52,17.9105801 10.2305801,19.2 8.64,19.2 C7.04941992,19.2 5.76,17.9105801 5.76,16.32 C5.76,14.7294199 7.04941992,13.44 8.64,13.44 Z M8.64,14.88 C7.84470996,14.88 7.2,15.52471 7.2,16.32 C7.2,17.11529 7.84470996,17.76 8.64,17.76 C9.43529004,17.76 10.08,17.11529 10.08,16.32 C10.08,15.52471 9.43529004,14.88 8.64,14.88 Z M9.12,1.37142857 C6.53530737,1.37142857 4.44,3.21345703 4.44,5.48571429 L4.44,8.64 L13.8,8.64 L13.8,5.48571429 C13.8,3.21345703 11.7046926,1.37142857 9.12,1.37142857 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EID---IT-Shop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ITShop---Computers---Details---Request-Access---Create-Master-Password-Initial",
    transform: "translate(-443.000000, -224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c/popups/computers/set-password",
    transform: "translate(395.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m/forms/input/type-2/password-normal",
    transform: "translate(32.000000, 168.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-lock",
    transform: "translate(16.000000, 15.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2acec663bdd1a893556d2bb63558fd05.svg";
export { ForwardRef as ReactComponent };